import { render, staticRenderFns } from "./safeSet.vue?vue&type=template&id=880d930c&scoped=true"
import script from "./safeSet.vue?vue&type=script&lang=js"
export * from "./safeSet.vue?vue&type=script&lang=js"
import style0 from "./safeSet.vue?vue&type=style&index=0&id=880d930c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880d930c",
  null
  
)

export default component.exports